const dev = {
    // API_URL: 'http://api.veloresults.com',
    API_URL: 'http://localhost:44341',
    SignalR_URL: 'http://signalr.veloresults.com/signalr/hubs',
    // SignalR_URL: 'http://localhost/SignalR%20TCM/'
};

const prod = {
    API_URL: 'http://api.veloresults.com',
    SignalR_URL: 'http://signalr.veloresults.com/signalr/hubs'
};
export const config = process.env.NODE_ENV === 'development' ? dev : prod;